import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get_order_details } from '../../store/reducers/orderReducer';
import { formatQ, ChevronLeft, Plus, WhatsApp } from '../home/ui';
import { Card, CardHead, PageHead, Pill, Steps, Thumb, orderStatus, payStatus, fecha, orderLabel, gbtn, useReorder } from '../account/shared';

// Detalle de un pedido (diseño cuenta.html → "Ver detalle").

const Row = ({ k, v, big }) => (
    <div className={`flex justify-between text-[14px] py-[6px] ${big ? 'text-[17px] font-extrabold text-[#0f172a] border-t border-[#f1efea] mt-[6px] pt-3' : 'text-[#334155]'}`}>
        <span>{k}</span><span>{v}</span>
    </div>
);

const OrderDetails = () => {
    const { orderId } = useParams();
    const dispatch = useDispatch();
    const { myOrder } = useSelector(state => state.order);
    const reorder = useReorder();

    useEffect(() => { dispatch(get_order_details(orderId)); }, [orderId]);

    const cargado = String(myOrder?._id) === String(orderId);
    const st = orderStatus(myOrder.delivery_status);
    const pay = payStatus(myOrder.payment_status);
    const prods = myOrder.products || [];
    const envio = myOrder.shippingInfo || {};
    const unidades = prods.reduce((s, p) => s + Number(p.quantity || 0), 0);

    return (
        <section>
            <Link to='/dashboard/my-orders' className={`${gbtn} mb-[18px]`}><ChevronLeft className='w-4 h-4' />Mis pedidos</Link>

            {!cargado ? (
                <Card className='animate-pulse'><div className='h-6 w-1/3 rounded bg-[#f1efea]' /><div className='h-16 rounded bg-[#faf9f6] mt-4' /></Card>
            ) : (
                <>
                    <PageHead title={`Pedido ${orderLabel(myOrder)}`}
                        sub={`Realizado el ${fecha(myOrder.date)} · ${unidades} producto${unidades === 1 ? '' : 's'}`}>
                        <Pill kind={st.kind} big>{st.label}</Pill>
                    </PageHead>

                    <Card>
                        {st.group === 'no' ? (
                            <div className='flex gap-3 items-center px-4 py-[14px] bg-[#fef2f2] rounded-[14px] text-[#b91c1c] text-[14px] font-semibold'>
                                Este pedido se canceló.
                            </div>
                        ) : (
                            <>
                                <Steps status={myOrder.delivery_status} />
                                {myOrder.promised_date && st.group === 'proc' && (
                                    <p className='text-center text-[13.5px] text-[#334155] mt-4 mb-0'>
                                        Entrega estimada: <b className='text-[#0f172a]'>{fecha(myOrder.promised_date, { weekday: 'long', day: 'numeric', month: 'long' })}</b>
                                    </p>
                                )}
                            </>
                        )}
                    </Card>

                    <div className='grid grid-cols-[minmax(0,1.5fr)_minmax(0,1fr)] lg:grid-cols-1 gap-[14px] mt-[14px]'>
                        <Card>
                            <CardHead title='Productos' />
                            {prods.map((p, i) => (
                                <div key={i} className='flex gap-[14px] items-center py-3 border-b border-[#f1efea] last:border-b-0'>
                                    <Thumb src={p.image} />
                                    <div className='flex-1 min-w-0 text-[14px] font-bold text-[#0f172a]'>
                                        {p.slug ? <Link to={`/product/details/${p.slug}`} className='hover:text-[#0891b2]'>{p.name}</Link> : p.name}
                                        <small className='block font-medium text-[#64748b] text-[12.5px] mt-[2px]'>
                                            {p.quantity} × {formatQ(p.price)}
                                            {p.supply_status === 'PENDIENTE_PROVEEDOR' && ' · Bajo pedido'}
                                        </small>
                                    </div>
                                    <span className='font-bold text-[#1e3a8a]'>{formatQ(p.quantity * p.price)}</span>
                                </div>
                            ))}
                            <div className='flex gap-2 mt-4 flex-wrap'>
                                {prods.length > 0 && <button type='button' onClick={() => reorder(myOrder)} className={gbtn}><Plus className='w-4 h-4' />Volver a pedir</button>}
                                <Link to='/dashboard/chat' className={gbtn}><WhatsApp className='w-4 h-4' />Ayuda con este pedido</Link>
                            </div>
                        </Card>

                        <div className='flex flex-col gap-[14px]'>
                            <Card>
                                <CardHead title='Resumen' />
                                <Row k='Subtotal' v={formatQ(myOrder.subtotal ?? myOrder.price)} />
                                <Row k='Envío' v={Number(myOrder.shippingFee) > 0 ? formatQ(myOrder.shippingFee) : <span className='text-[#15803d] font-bold'>Gratis</span>} />
                                <Row k='Total' v={formatQ(myOrder.price)} big />
                                <div className='flex justify-between items-center text-[14px] py-[6px] mt-2 text-[#334155]'>
                                    <span>Pago</span><Pill kind={pay.kind}>{pay.label}</Pill>
                                </div>
                            </Card>
                            <Card>
                                <CardHead title='Entrega' />
                                <div className='text-[14px] leading-[1.6] text-[#334155]'>
                                    {envio.name && <b className='text-[#0f172a]'>{envio.name}</b>}
                                    {[envio.address, [envio.municipality, envio.department].filter(Boolean).join(', ')].filter(Boolean).map((l, i) => <div key={i}>{l}</div>)}
                                    {envio.phone && <div>Tel. {envio.phone}</div>}
                                    {!envio.name && !envio.address && <span className='text-[#64748b]'>Sin datos de entrega.</span>}
                                </div>
                            </Card>
                        </div>
                    </div>
                </>
            )}
        </section>
    );
};

export default OrderDetails;
